export default {
    getAftercareDetails: (state) => state.aftercareDocumentDetails,
    isFormSubmitting: (state) => state.isSubmitting,
    isSubmissionCompleted: (state) => state.isSubmissionCompleted,
    isPreviewLoading: (state) => state.isPreviewing,
};